import React from 'react'
import {GatsbyImage, getImage} from 'gatsby-plugin-image'
import parse from 'html-react-parser'
import Link from '../utils/link'
import ProjectsFilter from './projects-filter'
import useProjectsQuery from '../hooks/use-projects-query'
import sal from 'sal.js'

const ProjectsArchive = ({title, projects, hideFilter, webWall }) => {

  const { allProjects, disciplines, sectors } = useProjectsQuery()

  const [list, setList] = React.useState(projects)
  const [filter, setFilter] = React.useState('')

  const props = {
    onMouseEnter: () => window?._handleMouseEnter('View'),
    onMouseLeave: () => window?._handleMouseLeave(),
  }

  React.useEffect(() => {
    if ( window.location?.search !== '') {
      let searchValue = decodeURIComponent(window.location?.search.replace('?filter=', ''))
      if (searchValue !== '') setFilter(searchValue)
    }
  }, [])

  React.useEffect(() => {
    sal()
  }, [list])

  return (
    <>
      { !hideFilter &&
        <ProjectsFilter 
          title={title}
          projects={projects}
          disciplines={disciplines}
          sectors={sectors}
          list={allProjects?.nodes || []}
          filter={filter}
          setFilter={setFilter}
          set={setList}
        />
      }
      <section className='featured-projects featured-projects--archive'>
        <div className='featured-projects__inner'>
          { list?.length &&
            <div className={`featured-projects__items${(filter === 'web-design' || webWall) ? ' featured-projects__items--digital' : ''}`}>
              { list?.map((el, i) => {
                if ( filter !== 'web-design' && !webWall ) {
                  let image = el.acf?.thumbnail?.landscapeImage?.localFile
                  if ((i + 1) % 2 === 0) image = el.acf?.thumbnail?.portraitImage?.localFile
                  return (
                    <Link key={i} to={el.uri} className='featured-projects__item' data-sal='slide-up' data-sal-duration='1000' data-sal-delay='0' data-sal-easing='ease' {...props}>
                      { el.acf.thumbnail?.video &&
                        <div className={`featured-projects__video-thumb featured-projects__video-thumb--${el.acf.thumbnail.videoSize}`}>
                          <video src={el.acf.thumbnail.video} autoPlay muted loop playsInline />
                        </div>
                      }
                      { !el.acf.thumbnail.video && image?.extension !== 'gif' && <GatsbyImage image={getImage(image)} alt={el.acf?.thumbnail?.landscapeImage?.altText} /> }
                      { !el.acf.thumbnail.video && image?.extension === 'gif' && <img className='gif' src={image.publicURL} alt={el.acf?.thumbnail?.landscapeImage?.altText} /> }
                      <div className='featured-projects__cap'>
                        { el.title && <h4>{parse(el.title)}</h4> }
                        { el.acf?.subtitle && <p>{parse(el.acf.subtitle)}</p> }
                      </div>
                    </Link>
                  )
                } else {
                  let video = el.acf.webGrid ? el.acf.webGrid : null
                  return (
                    <Link key={i} to={el.acf.noBio ? el.acf.projectInfo.website : el.uri} className='featured-projects__item' data-sal='slide-up' data-sal-duration='1000' data-sal-delay='0' data-sal-easing='ease' {...props}>
                      <div className='featured-projects__video-wrapper'>
                        { video && <video className='featured-projects__video' src={video} autoPlay muted loop playsInline /> }
                      </div>
                      <div className='featured-projects__cap'>
                        { el.title && <h4>{parse(el.title)}</h4> }
                      </div>
                    </Link>
                  )
                }
              })}
            </div>
          }
          { list?.length === 0 && <p className='featured-projects__no-results'>No results match your search criteria. Please try again.</p> }
        </div>
      </section>
    </>
  )
}

export default ProjectsArchive